import I18n from 'i18n-js';
import React from 'react';

import { LISTING_STATES } from './shared/constants';

interface IProps {
  state: string;
}

export default function Item2ListingState(props: IProps) {
  if (props.state === LISTING_STATES.LIVE) return null;

  const key = `discovery.item2ListingState.states.${props.state}`;

  return (
    <div
      className="button button--primary width-100"
      data-listing-state
      data-disabled
    >
      {I18n.t(key, { defaults: [{ message: '' }] })}
    </div>
  );
}
